import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  baseUrl: string;
  reservationEndpoint: string;

  constructor(private urlService: UrlService, private http: HttpClient) { 
    this.baseUrl = this.urlService.getBaseUrl();
    this.reservationEndpoint = "/CouchCafe/api/reservation";
  }

  public submitReservation(reservation: any) {
    return this.http.post(this.baseUrl + this.reservationEndpoint, reservation, {});
  }

  public getReservationsByDate(dateId: number) {
    return this.http.get(this.baseUrl + this.reservationEndpoint + "/" + dateId, {});
  }
}
